export default __webpack_public_path__ + "static/media/FactoryVideo.5ae5827f.mp4";